import { isNullOrUndefined } from '@/shared/lib/utils.ts'

export const getExistedProperties = <T extends object>(object: T): (keyof T)[] =>
  Object.keys(object).filter(k => !isNullOrUndefined(object[k])) as (keyof T)[]
